import styled from '@emotion/styled'
import React from 'react'

import { overrideOptional } from '@emico/overrides'

import useNonSpammyFieldState from './useNonSpammyFieldState'

const Container = styled.div`
  display: block;
  font-size: small;
  color: red;
`

interface Props {
  field: string
}

const FieldError = ({ field }: Props) => {
  const { error } = useNonSpammyFieldState(field)

  if (!error) {
    return null
  }

  return (
    <Container role="alert" data-testid={`fielderror-for-${field}`}>
      {error}
    </Container>
  )
}

export default overrideOptional(FieldError)
